import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IonInput } from '@ionic/angular';

@Component({
  selector: 'app-select-search-input',
  templateUrl: './select-search-input.component.html',
  styleUrls: ['./select-search-input.component.scss'],
})
export class SelectSearchInputComponent {
  @ViewChild('inputField', { static: false }) inputField!: IonInput;
  @Input() isRequired: boolean = true;
  @Input() disabled: boolean = false;
  @Input() innerClass: string = '';
  @Input() allData: any = [];
  @Input() label: string = '';
  @Input() selectInput: any = null;
  @Input() selectInputId: any = null;
  @Output() selectInputChange = new EventEmitter<any>();
  @Output() selectInputIdChange = new EventEmitter<any>();
  @Input() helperText: string = '';
  @Input() errorText: string = 'Campo inválido.';
  @Input() isMobile: boolean = false;

  filteredData: any = [];
  inputFocus: boolean = false;
  optSelected: boolean = false;
  inputWasChanged: boolean = false;
  lastKeyPressed: string = '';
  @Input() isFromUser: boolean = false;
  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      input: [null],
    });
  }

  ngOnInit(): void {
    if (this.selectInput) {
      this.form.patchValue({ input: this.selectInput });
    }
    this.filteredData = this.allData;
  }

  setFieldValidation() {
    const inputControl = this.form.get('input');

    if (!inputControl) return;

    if (this.isRequired) {
      inputControl.setValidators([Validators.required]);
    } else {
      inputControl.clearValidators();
    }
    inputControl.updateValueAndValidity();
  }

  onKeyDown(event: KeyboardEvent) {
    this.lastKeyPressed = event.key;
  }

  onFocus(event: CustomEvent): void {
    const focusEvent = event.detail as FocusEvent;

    if (this.lastKeyPressed === 'Clear') {
      this.lastKeyPressed = '';
      return;
    }

    this.lastKeyPressed = '';
    this.inputFocus = true;
    this.inputWasChanged = false;

    if (!this.form.get('input')?.value) {
      this.filteredData = this.allData;
    }
  }

  onInputChange() {
    this.inputWasChanged = true;
  }

  onBlur(event: CustomEvent) {
    const blurEvent = event.detail as FocusEvent;

    if (!this.inputFocus) {
      return false;
    }

    if (this.lastKeyPressed === 'Tab') {
      return false;
    }

    return this.closeList();
  }

  onListBlur(event: FocusEvent) {
    const relatedTarget = event.relatedTarget as HTMLElement;
    if (!relatedTarget || !this.isFocusInsideList(relatedTarget)) {
      return this.closeList();
    }
  }

  clearInput() {
    this.lastKeyPressed = 'Clear';

    this.clearInputAction();

    setTimeout(() => {
      this.inputField.getInputElement().then((nativeInput) => {
        nativeInput.blur();
      });
    }, 0);
  }

  private clearInputAction() {
    this.form.patchValue({ input: null });
    this.selectInput = null;
    this.selectInputId = null;
    this.selectInputChange.emit(null);
    this.selectInputIdChange.emit(null);
  }

  private isFocusInsideList(target: HTMLElement): boolean {
    const listElement = document.querySelector('.filtered-list');
    return listElement ? listElement.contains(target) : false;
  }

  private closeList() {
    setTimeout(() => {
      this.inputFocus = false;
      if (this.inputWasChanged && !this.optSelected) {
        this.clearInputAction();
      }
    }, 150);
  }

  onSearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;

    if (filterValue) {
      this.optSelected = false;
      const lowerCaseSearchTerm = filterValue.toLowerCase();
      this.filteredData = this.allData.filter((data: any) =>
        data.nome.toLowerCase().includes(lowerCaseSearchTerm)
      );
    } else {
      this.filteredData = this.allData;
    }
  }

  selectValue(value: any, event: MouseEvent) {
    event.preventDefault();
    this.optSelected = true;
    this.filteredData = [];
    this.form.patchValue({ input: value.nome });
    this.selectInput = value.nome;
    this.selectInputId = value.id;
    this.selectInputChange.emit(value.nome);
    this.selectInputIdChange.emit(value.id);
  }

  keydownSelectValue(event: KeyboardEvent) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
    }
  }
}
